// Local stub for builds. Real config lives on dev machines (gitignored).
export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCCTaJDbV2R2waIV3Ojroq4cc55TCmy6o8",
    authDomain: "barbershop-d.firebaseapp.com",
    databaseURL: "https://barbershop-d-default-rtdb.firebaseio.com",
    projectId: "barbershop-d",
    storageBucket: "barbershop-d.appspot.com",
    messagingSenderId: "520340218800",
    appId: "1:520340218800:web:9c2a4bfdd29d8be0e76c75",
    measurementId: "G-1QHR7L94WY"
  },
};
